import Loading from "vue-loading-overlay";

export default {
  install(Vue) {
    Vue.use(Loading);
    Vue.component("Loading", Loading);
    Vue.prototype.$showLoader = function () {
      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        backgroundColor: "#fff",
        color: "#2dce89",
        width: 128,
        height: 128
      });
      Vue.prototype.$stopLoader = function () {
        loader.hide();
      }
      return loader;
    }
  }
}
